/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { EvaluationsAndRoutineFrequenciesViewModel } from './EvaluationsAndRoutineFrequenciesViewModel'; 

export function getEvaluationsAndRoutineFrequenciesForOrderOptions(orderId: string, onSuccess?: (result: EvaluationsAndRoutineFrequenciesViewModel) => void) {
	return queryOptions({
		queryKey: ['evaluations-and-routine-frequencies-for-order', orderId],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/frequencies/queries/getevaluationsandroutinefrequenciesfororder/' + orderId;
			const resp = await axios.get<EvaluationsAndRoutineFrequenciesViewModel>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(orderId)
	});
}